// extracted by mini-css-extract-plugin
export default {"main":"Loading_main__gwlQ6","spinner":"Loading_spinner__JkmWW","spin":"Loading_spin__KpSl0"};